export default {"src":"/_next/static/media/fence.8767035e.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};